
<div class = "page-container">
  <div class = " main-body">
<div class = "profile-detail-container">
  <div class = 'profile-detail-header'>
    <div>
      <h1 class = "mat-display-large"> {{ profile?.title }} {{ profile?.firstname}} {{ profile?.lastname}}</h1>
      <h2 class = "mat-display-medium"> {{ profile?.role }}</h2>
      <h3 class = "mat-headline-medium"> {{ profile?.qual }}</h3>
    </div>
    <div class = "separator"></div>
    <div class = button-container>
      <app-button-shared buttonType="our-team" buttonText = "Back to Doctors"></app-button-shared>
    </div>
    <div class = button-container>
    </div>
  </div>

  <div class = 'profile-detail-content'>
    <div *ngFor="let paragraph of profile?.desc" class = 'profile-detail-paragraph'>
      <p>{{ paragraph }}</p>
    </div>
    <div class="profile-button-container">
      <app-button-contact-enquire></app-button-contact-enquire>
    </div>
  </div>

  <div class = 'profile-detail-image-container' *ngIf="profile?.url as imageUrl">
    <img class = 'profile-detail-image'
         [ngSrc]="imageUrl"
         priority
         [style.object-position]="profile?.centerX + ' ' + profile?.centerY"
         alt="Exterior photo of {{ profile?.title }} {{ profile?.firstname}} {{ profile?.lastname}}"
         crossorigin fill
    />
  </div>
</div>
  </div>
</div>
